// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // WEB_API_URL: 'http://fusioniprojects.com/swig',
  WEB_API_URL: "https://www.swigappmanager.com",
  // STRIPE_PAYMENT_API_URL: "https://stripeapi.swigit.com",
  STRIPE_PAYMENT_API_URL: "https://www.swigappmanager.com",
  SUPPORT_API_URL: "https://www.swigappmanager.com",
  DEMO_API_URL: "https://demo.swigappmanager.com",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
